import * as Actions from 'app/store/actions/ctm/tft.actions';
import { RESET_CTM } from 'app/store/actions/ctm/landing.actions';

const initialState = {
	data: [],
};

const tftReducer = (state = initialState, action) => {
	switch (action.type) {
		case RESET_CTM: {
			return { ...initialState };
		}
		case Actions.UPLOAD_FILE: {
			return {
				...state,
			};
		}
        case Actions.LIST_FILE_IN_PROJECT: {
			return {
				...state,
				files: action.data,
			};
		}
        case Actions.GET_TFT_FROM_TD: {
			console.log("GET_TFT_FROM_TD", action)
			return {
				...state,
				data: action.data,
			};
		}
		default: {
			return state;
		}
	}
};

export default tftReducer;
